/* Furniversal content loader — Shopify build (generated by shopify/build.mjs) */
/* =========================================================
   FURNIVERSAL — website content loader
   ---------------------------------------------------------
   Merges data/content.json (saved from the admin panel) over
   the built-in defaults in content-schema.js, then writes the
   result into the page.

   If the API isn't reachable — e.g. the static Vercel deploy —
   the page simply keeps the copy that's already in the HTML,
   so the site never goes blank.

   Hooks used in the HTML:
     data-fv-text="path"     replace the element's text
     data-fv-rich="path"     same, but *word* → italic and line breaks kept
     data-fv-html="path"     paragraphs (blank line = new <p>)
     data-fv-src="path"      swap an <img> / <video> / <source> file
     data-fv-poster="path"   swap a video's placeholder image
     data-fv-alt="path"      swap an image's alt text
     data-fv-content="path"  swap a <meta> tag's content
     data-fv-href="path"     swap a link's destination
     data-fv-mailto="path"   turn an address into a mailto: link
     data-fv-list="path"     rebuild a repeating block (cards, steps…)
   ========================================================= */
(function () {
  "use strict";

  var DEFAULTS = window.FV_CONTENT_DEFAULTS || {};
  var FETCH_TIMEOUT = 3500;

  /* ---------------- tiny helpers ---------------- */
  function isPlainObject(v) {
    return v && typeof v === "object" && !Array.isArray(v);
  }
  function deepMerge(base, over) {
    if (!isPlainObject(over)) return (over === undefined || over === null) ? base : over;
    var out = {};
    Object.keys(base || {}).forEach(function (k) { out[k] = base[k]; });
    Object.keys(over).forEach(function (k) {
      out[k] = isPlainObject(base && base[k]) ? deepMerge(base[k], over[k]) : over[k];
    });
    return out;
  }
  function clone(v) { return JSON.parse(JSON.stringify(v)); }

  function get(path, fallback) {
    var node = window.FV_CONTENT;
    var parts = String(path || "").split(".");
    for (var i = 0; i < parts.length; i++) {
      if (node === null || node === undefined) return fallback;
      node = node[parts[i]];
    }
    // "" is a deliberate blank from the admin, so only a missing value falls back
    return (node === undefined || node === null) ? fallback : node;
  }

  function esc(s) {
    return String(s === null || s === undefined ? "" : s)
      .replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
  }
  // *word* → italic, line breaks preserved
  function rich(s) {
    return esc(s).replace(/\*([^*]+)\*/g, "<em>$1</em>").replace(/\n/g, "<br>");
  }
  // blank line between paragraphs → separate <p>
  function paras(s) {
    return String(s || "").split(/\n\s*\n/).map(function (p) {
      return p.trim() ? "<p>" + esc(p.trim()).replace(/\n/g, "<br>") + "</p>" : "";
    }).join("");
  }
  // one entry per line
  function lines(s) {
    if (Array.isArray(s)) return s.filter(Boolean);
    return String(s || "").split("\n").map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function list(path) {
    var v = get(path, []);
    return Array.isArray(v) ? v : [];
  }

  /* ---------------- links ----------------
     "whatsapp:Message"  → a wa.me link with the current number
     any wa.me/<digits>  → rewritten to the current number
     everything else     → left alone                        */
  function waNumber() {
    return String(get("global.whatsapp.number", "")).replace(/\D/g, "") || "919148236891";
  }

  function waLink(message) {
    var msg = message || get("global.whatsapp.greeting", "Hi Furniversal!");
    return "https://wa.me/" + waNumber() + "?text=" + encodeURIComponent(msg);
  }
  function resolveHref(href) {
    var h = String(href || "");
    if (/^whatsapp:/i.test(h)) return waLink(h.replace(/^whatsapp:\s*/i, ""));
    if (/wa\.me\/\d+/.test(h)) return h.replace(/(wa\.me\/)\d+/, "$1" + waNumber());
    return window.FV_URL ? window.FV_URL(h) : h;
  }
  function isExternal(href) { return /^https?:\/\//i.test(href); }

  function linkAttrs(href) {
    var h = resolveHref(href);
    return 'href="' + esc(h) + '"' + (isExternal(h) ? ' target="_blank" rel="noopener"' : "");
  }

  /* ---------------- icons ---------------- */
  var ICON_PATHS = {
    shield: '<path d="M12 2l8 3v6c0 6-8 11-8 11S4 17 4 11V5z"/>',
    layers: '<path d="M3 7l9-4 9 4-9 4-9-4zm0 5l9 4 9-4M3 17l9 4 9-4"/>',
    price:  '<path d="M12 3v18M5 8h14M5 16h14"/>',
    person: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>',
    star:   '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.4 1 6.1L12 17.8l-5.5 2.9 1-6.1-4.4-4.4 6.1-.9z"/>',
    truck:  '<path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
    check:  '<path d="M20 6L9 17l-5-5"/>',
    ruler:  '<path d="M3 17L17 3l4 4L7 21z"/><path d="M14 6l1.5 1.5M11 9l1.5 1.5M8 12l1.5 1.5"/>',
    seat:   '<path d="M5 11V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v4"/><path d="M3 13a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3H3z"/><path d="M5 16v3M19 16v3"/>',
    fabric: '<path d="M4 4h16v16H4z"/><path d="M4 9h16M4 14h16M9 4v16M14 4v16"/>',
    palette:'<path d="M12 3a9 9 0 1 0 0 18c1.2 0 2-.8 2-1.8 0-.6-.3-1-.6-1.4-.3-.4-.6-.8-.6-1.3 0-1 .8-1.8 1.8-1.8H16a5 5 0 0 0 5-5c0-3.9-4-6.7-9-6.7z"/><circle cx="7.5" cy="10.5" r="1"/><circle cx="10.5" cy="7" r="1"/><circle cx="14.5" cy="7" r="1"/><circle cx="17" cy="10" r="1"/>',
    clock:  '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    sofa:   '<path d="M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3"/><path d="M2 13a2 2 0 0 1 2-2 2 2 0 0 1 2 2v2h12v-2a2 2 0 0 1 4 0v5H2z"/>',
    hand:   '<path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12M11 12V4.5a1.5 1.5 0 0 1 3 0V12M14 12V6.5a1.5 1.5 0 0 1 3 0V13"/><path d="M17 13v2a6 6 0 0 1-12 0v-4l-1.5-2A1.5 1.5 0 0 1 6 7.5L8 10"/>',
    eye:    '<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
    chat:   '<path d="M4 5h16v11H8l-4 4z"/>',
    map:    '<circle cx="12" cy="10" r="3"/><path d="M12 21s7-5.5 7-11a7 7 0 0 0-14 0c0 5.5 7 11 7 11z"/>',
    phone:  '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/>',
    mail:   '<path d="M4 6h16v12H4z"/><path d="M4 7l8 6 8-6"/>',
    award:  '<circle cx="12" cy="9" r="5"/><path d="M8.5 13.5L7 21l5-2.5L17 21l-1.5-7.5"/>',
    pen:    '<path d="M4 20l4-1 10-10-3-3L5 16z"/><path d="M13 7l3 3"/>',
    home:   '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/>',
    refresh:'<path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v5h-5"/>',
    tool:   '<path d="M14.7 6.3a4 4 0 0 0 5 5L13 18l-3-3 6.7-6.7z"/><path d="M4 20l6-6"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICON_PATHS[name] || ICON_PATHS.check) + "</svg>";
  }
  var GOOGLE_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path fill="#4285F4" d="M23 12.2c0-.8-.1-1.6-.2-2.3H12v4.5h6.2a5.3 5.3 0 0 1-2.3 3.5v2.9h3.7C21.7 18.9 23 15.9 23 12.2z"/>' +
    '<path fill="#34A853" d="M12 23c3.1 0 5.7-1 7.6-2.8l-3.7-2.9c-1 .7-2.3 1.1-3.9 1.1-3 0-5.5-2-6.4-4.7H1.8v3C3.7 20.5 7.5 23 12 23z"/>' +
    '<path fill="#FBBC05" d="M5.6 13.7a6.6 6.6 0 0 1 0-3.4v-3H1.8a11 11 0 0 0 0 9.4z"/>' +
    '<path fill="#EA4335" d="M12 6.5c1.7 0 3.2.6 4.4 1.7l3.3-3.3C17.7 3 15.1 2 12 2 7.5 2 3.7 4.5 1.8 8.3l3.8 3c.9-2.7 3.4-4.8 6.4-4.8z"/>' +
    "</svg>";

  function initial(name) { return esc(String(name || "?").trim().charAt(0).toUpperCase()); }
  var AVATAR_COLOURS = ["var(--olive)", "var(--brass)", "#3f8e8c", "#7a5c3e", "#4a6070"];

  /* =========================================================
     Renderers for the repeating blocks
     ========================================================= */
  var RENDERERS = {
    "global.nav": function (path, el) {
      var here = String((window.FV_SHOPIFY && window.FV_SHOPIFY.legacyPage) || "").toLowerCase();
      return list(path).map(function (it) {
        var target = String(it.href || "").split("#")[0].toLowerCase();
        var active = target && target === here ? ' class="active"' : "";
        return "<a " + linkAttrs(it.href) + active + ">" + esc(it.label) + "</a>";
      }).join("");
    },

    "global.footer.exploreLinks": footerLinks,
    "global.footer.categoryLinks": footerLinks,

    "global.footer.notes": function (path) {
      return lines(get(path, "")).map(function (n) { return "<p>" + esc(n) + "</p>"; }).join("");
    },

    "global.footer.contact": function () {
      var num = waNumber();
      var email = get("global.contact.email", "");
      return (
        '<a href="https://wa.me/' + esc(num) + '" target="_blank" rel="noopener">WhatsApp: ' +
          esc(get("global.whatsapp.display", "+91 91482 36891")) + "</a>" +
        (email ? '<a href="mailto:' + esc(email) + '">Email: ' + esc(email) + "</a>" : "") +
        '<a href="' + esc(get("global.contact.instagramUrl", "#")) + '" target="_blank" rel="noopener">Instagram: ' +
          esc(get("global.contact.instagramHandle", "")) + "</a>"
      );
    },

    "global.socials": function () {
      var num = waNumber();
      var wa = '<svg viewBox="0 0 24 24"><path d="M17.5 14.4c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.6.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.7-.8-2.8-1.5-3.9-3.4-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5 0-.2-.6-1.6-.9-2.2-.2-.5-.4-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 1.8.8 2.5.8 3.4.7.6 0 1.7-.7 2-1.4.2-.6.2-1.2.2-1.4-.1-.1-.3-.2-.5-.3zM12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.3A10 10 0 1 0 12 2z"/></svg>';
      var ig = '<svg viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.1.4.3 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.1-1 .3-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.1-.4-.3-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.1 1-.3 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 3.2A6.6 6.6 0 1 0 18.6 12 6.6 6.6 0 0 0 12 5.4zm0 10.9A4.3 4.3 0 1 1 16.3 12 4.3 4.3 0 0 1 12 16.3zm6.8-11.2a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5z"/></svg>';
      var fb = '<svg viewBox="0 0 24 24"><path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H8v3h3v7h3v-7h2.5l.5-3H14V9z"/></svg>';
      var out =
        '<a href="https://wa.me/' + esc(num) + '" target="_blank" rel="noopener" aria-label="WhatsApp">' + wa + "</a>" +
        '<a href="' + esc(get("global.contact.instagramUrl", "#")) + '" target="_blank" rel="noopener" aria-label="Instagram">' + ig + "</a>";
      var yt = '<svg viewBox="0 0 24 24"><path d="M23 7.2c-.3-1-1-1.8-2-2C19.2 4.7 12 4.7 12 4.7s-7.2 0-9 .5c-1 .3-1.8 1-2 2C.5 9 .5 12 .5 12s0 3 .5 4.8c.3 1 1 1.8 2 2 1.8.5 9 .5 9 .5s7.2 0 9-.5c1-.3 1.8-1 2-2 .5-1.8.5-4.8.5-4.8s0-3-.5-4.8zM9.7 15.1V8.9l6 3.1-6 3.1z"/></svg>';
      var pin = '<svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.8 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.9 1.6 1.9 1.9 0 3.3-2 3.3-4.8 0-2.5-1.8-4.3-4.4-4.3-3 0-4.8 2.3-4.8 4.6 0 .9.3 1.9.8 2.4.1.1.1.2.1.3l-.3 1.2c0 .2-.2.2-.4.1-1.3-.6-2.1-2.5-2.1-4 0-3.3 2.4-6.3 6.9-6.3 3.6 0 6.4 2.6 6.4 6 0 3.6-2.3 6.5-5.4 6.5-1.1 0-2.1-.6-2.4-1.2l-.7 2.5c-.2.9-.9 2.1-1.3 2.8A10 10 0 1 0 12 2z"/></svg>';
      var x = '<svg viewBox="0 0 24 24"><path d="M17.5 3h3.3l-7.2 8.2L22 21h-6.6l-5.2-6.8L4.3 21H1l7.7-8.8L.6 3h6.8l4.7 6.2L17.5 3zm-1.2 16h1.8L6.4 4.9H4.5L16.3 19z"/></svg>';
      var ytUrl = get("global.contact.youtubeUrl", ""), pinUrl = get("global.contact.pinterestUrl", ""), xUrl = get("global.contact.xUrl", "");
      var fbUrl = get("global.contact.facebookUrl", "");
      if (ytUrl && ytUrl !== "#") out += '<a href="' + esc(ytUrl) + '" target="_blank" rel="noopener" aria-label="YouTube">' + yt + "</a>";
      if (pinUrl && pinUrl !== "#") out += '<a href="' + esc(pinUrl) + '" target="_blank" rel="noopener" aria-label="Pinterest">' + pin + "</a>";
      if (xUrl && xUrl !== "#") out += '<a href="' + esc(xUrl) + '" target="_blank" rel="noopener" aria-label="X">' + x + "</a>";
      if (fbUrl && fbUrl !== "#") out += '<a href="' + esc(fbUrl) + '" target="_blank" rel="noopener" aria-label="Facebook">' + fb + "</a>";
      return out;
    },

    "home.trust": function (path) {
      return list(path).map(function (it) {
        return '<div class="trust-item">' + icon(it.icon) + " " + esc(it.text) + "</div>";
      }).join("");
    },

    "home.promise.cards": numberedCards,
    "interiors.pillars.cards": numberedCards,

    "interiors.philosophy.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<div class="triad-card" data-reveal data-reveal-delay="' + i + '">' +
          '<div class="t-name">' + esc(c.title) + "</div><p>" + esc(c.text) + "</p></div>";
      }).join("");
    },

    "home.categories.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<a class="cat-card" ' + linkAttrs(c.href) + ' data-reveal data-reveal-delay="' + i + '">' +
          '<img src="' + esc(window.FV_URL(c.image)) + '" alt="' + esc(c.title) + '" />' +
          '<div class="cat-label"><span>' + esc(c.kicker) + "</span><h3>" + esc(c.title) + "</h3></div></a>";
      }).join("");
    },

    "interiors.portfolio.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<div class="cat-card" data-reveal data-reveal-delay="' + i + '">' +
          '<img src="' + esc(window.FV_URL(c.image)) + '" alt="' + esc(c.title) + '" />' +
          '<div class="cat-label"><span>' + esc(c.kicker) + "</span><h3>" + esc(c.title) + "</h3></div></div>";
      }).join("");
    },

    "home.split.bullets": function (path) {
      return lines(get(path, "")).map(function (b) { return "<li>" + esc(b) + "</li>"; }).join("");
    },
    "brands.house.pills": function (path) {
      return lines(get(path, "")).map(function (p) { return '<span class="pill">' + esc(p) + "</span>"; }).join("");
    },

    "home.process.steps": steps,
    "interiors.process.steps": steps,

    "home.testimonials.items": function (path) {
      return list(path).map(function (it, i) {
        return '<div class="testi-card" data-reveal data-reveal-delay="' + i + '">' +
          '<div class="testi-stars">★★★★★</div>' +
          "<blockquote>&quot;" + esc(it.quote) + "&quot;</blockquote>" +
          '<div class="testi-author"><div class="testi-avatar">' + initial(it.name) + "</div>" +
          '<div><div class="name">' + esc(it.name) + '</div><div class="place">' + esc(it.place) + "</div></div></div></div>";
      }).join("");
    },

    "home.reviews.items": function (path) {
      return list(path).map(function (it, i) {
        return '<div class="review-card" data-reveal data-reveal-delay="' + i + '">' +
          '<div class="review-head">' +
            '<span class="review-avatar" style="background:' + AVATAR_COLOURS[i % AVATAR_COLOURS.length] + '">' + initial(it.name) + "</span>" +
            '<div><div class="review-name">' + esc(it.name) + "</div>" +
            '<div class="review-meta"><span class="review-stars">★★★★★</span><span class="review-time">' + esc(it.time) + "</span></div></div>" +
          "</div><p>" + esc(it.text) + "</p>" +
          '<div class="review-source">' + GOOGLE_SVG + " Posted on Google</div></div>";
      }).join("");
    },

    "home.faq.items": function (path) {
      return list(path).map(function (it) {
        return '<div class="faq-item"><button class="faq-q">' + esc(it.q) +
          '<span class="faq-icon"></span></button><div class="faq-a"><p>' + esc(it.a) + "</p></div></div>";
      }).join("");
    },

    "home.contact.interests": function (path) {
      return lines(get(path, "")).map(function (o) { return "<option>" + esc(o) + "</option>"; }).join("");
    },

    "brands.partners": function (path) {
      return list(path).map(function (b, i) {
        var tags = String(b.tags || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);
        return '<div class="brand-card" data-reveal data-reveal-delay="' + i + '">' +
          '<span class="brand-kicker">' + esc(b.kicker) + "</span>" +
          '<h3 class="brand-logo"><img src="' + esc(window.FV_URL(b.logo)) + '" alt="' + esc(b.name) + '" /></h3>' +
          '<div class="brand-sub">' + esc(b.sub) + "</div><p>" + esc(b.text) + "</p>" +
          '<div class="brand-tags">' + tags.map(function (tg) { return '<span class="tag">' + esc(tg) + "</span>"; }).join("") + "</div></div>";
      }).join("");
    },

    "brands.about.stats": function (path) {
      return list(path).map(function (s) {
        return '<div class="stat-card"><div class="stat-num">' + esc(s.num) +
          "<span>" + esc(s.suffix) + '</span></div><div class="stat-label">' + esc(s.label) + "</div></div>";
      }).join("");
    },

    /* ---------- 2026-09 redesign blocks ---------- */
    "global.footer.policyLinks": footerLinks,

    "home.hero.pills": function (path) {
      return lines(get(path, "")).map(function (x) { return "<span>" + esc(x) + "</span>"; }).join("");
    },
    "home.proof": function (path) {
      return list(path).map(function (it) {
        return '<div class="proof-item"><strong>' + esc(it.num) + "</strong><span>" + esc(it.label) + "</span></div>";
      }).join("");
    },
    "home.categories.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<a class="cat-tile" ' + linkAttrs(c.href) + ' data-reveal data-reveal-delay="' + (i % 4) + '">' +
          '<div class="cat-img"><img src="' + esc(c.image) + '" alt="' + esc(c.title) + '" loading="lazy" /></div>' +
          "<h3>" + esc(c.title) + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></h3>' +
          (c.kicker ? "<span>" + esc(c.kicker) + "</span>" : "") + "</a>";
      }).join("");
    },
    "home.custom.tiles": iconTiles("custom-tile"),
    "showroom.experience.cards": iconTiles("exp-card"),

    "home.estimate.types":     chips("type"),
    "home.estimate.materials": chips("material"),
    "home.estimate.budgets":   chips("budget"),

    "home.compare.standardItems": plainList,
    "home.compare.customItems":   plainList,
    "home.showroom.list":         plainList,
    "shop.help": function (path) {
      return lines(get(path, "")).map(function (x) {
        return "<span>" + icon("check") + esc(x) + "</span>";
      }).join("");
    },

    "product.customise.steps": steps,
    "showroom.visit.interests": function (path) {
      return lines(get(path, "")).map(function (o) { return "<option>" + esc(o) + "</option>"; }).join("");
    },
    "showroom.hero.facts": function (path) {
      return list(path).map(function (f) { return "<div><strong>" + esc(f.num) + "</strong><span>" + esc(f.label) + "</span></div>"; }).join("");
    },
    "support.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<div class="support-card" data-reveal data-reveal-delay="' + i + '">' +
          '<div class="ct-icon">' + icon(c.icon) + "</div><h3>" + esc(c.title) + "</h3><p>" + esc(c.text) + "</p>" +
          '<a class="btn btn-primary" ' + linkAttrs(c.btnHref) + ">" + esc(c.btnLabel) + "</a></div>";
      }).join("");
    },
    "support.warranty.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<div class="warranty-card" data-reveal data-reveal-delay="' + (i % 3) + '"><h3>' + esc(c.title) + "</h3><ul>" +
          lines(c.items).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>";
      }).join("");
    },
    "support.policies.blocks": function (path) {
      // policies are collapsed like the FAQ; a #anchor in the address opens the matching one
      return list(path).map(function (b) {
        var id = String(b.id || b.title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
        return '<div class="faq-item policy-item" id="' + esc(id) + '"><button class="faq-q">' + esc(b.title) +
          '<span class="faq-icon"></span></button><div class="faq-a"><div class="policy-body">' + paras(b.body) + "</div></div></div>";
      }).join("");
    },
    "home.categories.more": function (path) {
      return lines(get(path, "")).map(function (x) {
        return '<a class="more-chip" target="_blank" rel="noopener" href="' + esc(waLink("Hi Furniversal, I'm looking for " + x.toLowerCase() + ". Please share options.")) + '">' + esc(x) + "</a>";
      }).join("");
    },
    "showroom.stories.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<figure class="story-card" data-reveal data-reveal-delay="' + (i % 4) + '">' +
          '<img src="' + esc(window.FV_URL(c.image)) + '" alt="" loading="lazy" />' +
          "<figcaption><blockquote>&ldquo;" + esc(c.quote) + "&rdquo;</blockquote><span>" + esc(c.name) + "</span></figcaption></figure>";
      }).join("");
    },
    "support.care.cards": function (path) {
      return list(path).map(function (c, i) {
        return '<div class="warranty-card" data-reveal data-reveal-delay="' + (i % 3) + '"><h3>' + esc(c.title) + "</h3><ul>" +
          lines(c.items).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul></div>";
      }).join("");
    },
    "support.policies.nav": function () {
      return list("support.policies.blocks").map(function (b) {
        var id = String(b.id || b.title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
        return '<a href="#' + esc(id) + '">' + esc(b.title) + "</a>";
      }).join("");
    }
  };

  function iconTiles(cls) {
    return function (path) {
      return list(path).map(function (c, i) {
        return '<div class="' + cls + '" data-reveal data-reveal-delay="' + (i % 4) + '">' +
          '<div class="ct-icon">' + icon(c.icon) + "</div><h3>" + esc(c.title) + "</h3><p>" + esc(c.text) + "</p></div>";
      }).join("");
    };
  }
  function chips(name) {
    return function (path) {
      return lines(get(path, "")).map(function (o, i) {
        return '<label class="chip"><input type="radio" name="' + name + '" value="' + esc(o) + '"' + (i === 0 ? " checked" : "") + "><span>" + esc(o) + "</span></label>";
      }).join("");
    };
  }
  function plainList(path) {
    return lines(get(path, "")).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("");
  }

  function footerLinks(path) {
    return list(path).map(function (it) {
      return "<a " + linkAttrs(it.href) + ">" + esc(it.label) + "</a>";
    }).join("");
  }
  function numberedCards(path) {
    return list(path).map(function (c, i) {
      return '<div class="promise-card" data-reveal data-reveal-delay="' + i + '">' +
        '<div class="num">' + esc(c.num) + "</div><h3>" + esc(c.title) + "</h3><p>" + esc(c.text) + "</p></div>";
    }).join("");
  }
  function steps(path) {
    return list(path).map(function (s, i) {
      return '<div class="step" data-reveal data-reveal-delay="' + i + '">' +
        '<div class="step-num">' + esc(s.num) + "</div><h4>" + esc(s.title) + "</h4><p>" + esc(s.text) + "</p></div>";
    }).join("");
  }

  /* =========================================================
     Apply the content to the page
     ========================================================= */
  function applyAttr(selector, fn) {
    document.querySelectorAll("[" + selector + "]").forEach(function (el) {
      var path = el.getAttribute(selector);
      var val = get(path, null);
      if (val === null || val === undefined) return;
      fn(el, val, path);
    });
  }

  function apply() {
    // --- text ---
    applyAttr("data-fv-text", function (el, val) {
      el.textContent = String(val);
      if (el.tagName === "TITLE") document.title = String(val);
    });
    applyAttr("data-fv-content", function (el, val) { el.setAttribute("content", String(val)); });
    applyAttr("data-fv-rich", function (el, val) { el.innerHTML = rich(val); });
    applyAttr("data-fv-html", function (el, val) { el.innerHTML = paras(val); });
    applyAttr("data-fv-alt", function (el, val) { el.setAttribute("alt", String(val)); });

    // --- media ---
    var reload = [];
    applyAttr("data-fv-src", function (el, val) {
      if (!String(val)) return;                       // nothing chosen, keep the built-in file
      if (el.getAttribute("src") === String(val)) return;
      el.setAttribute("src", window.FV_URL(String(val)));
      var vid = el.closest("video");
      if (vid && reload.indexOf(vid) === -1) reload.push(vid);
    });
    applyAttr("data-fv-poster", function (el, val) { if (String(val)) el.setAttribute("poster", window.FV_URL(String(val))); });
    applyAttr("data-fv-mailto", function (el, val) { if (String(val)) el.setAttribute("href", "mailto:" + String(val)); });
    reload.forEach(function (v) { try { v.load(); } catch (e) {} });

    // --- links ---
    applyAttr("data-fv-href", function (el, val) {
      if (!String(val)) return;                       // no link set, keep the built-in one
      var h = resolveHref(String(val));
      el.setAttribute("href", h);
      if (isExternal(h)) { el.setAttribute("target", "_blank"); el.setAttribute("rel", "noopener"); }
    });

    // --- repeating blocks ---
    document.querySelectorAll("[data-fv-list]").forEach(function (el) {
      var path = el.getAttribute("data-fv-list");
      var fn = RENDERERS[path];
      if (!fn) return;
      var html = fn(path, el);
      if (html !== null && html !== undefined && html !== "") el.innerHTML = html;
    });

    // --- any remaining hard-coded WhatsApp link picks up the current number ---
    var num = waNumber();
    document.querySelectorAll('a[href*="wa.me/"]').forEach(function (a) {
      a.setAttribute("href", a.getAttribute("href").replace(/(wa\.me\/)\d+/, "$1" + num));
    });

    document.dispatchEvent(new CustomEvent("fv:content"));
  }

  /* =========================================================
     Load
     ========================================================= */
  window.FV_CONTENT = clone(DEFAULTS);
  window.FV = { get: get, waLink: waLink, resolveHref: resolveHref, lines: lines, esc: esc, apply: apply,
    reload: function (saved) { window.FV_CONTENT = deepMerge(DEFAULTS, saved || {}); apply(); } };

  function fetchSaved() {
    // Shopify: the theme editor's settings are printed into the page by each section
    return Promise.resolve(window.FV_SHOPIFY && window.FV_SHOPIFY.savedContent ? window.FV_SHOPIFY.savedContent() : null);
  }

  window.FV_CONTENT_READY = fetchSaved().then(function (saved) {
    if (saved && typeof saved === "object" && Object.keys(saved).length) {
      window.FV_CONTENT = deepMerge(DEFAULTS, saved);
    }
    if (document.readyState === "loading") {
      return new Promise(function (resolve) {
        document.addEventListener("DOMContentLoaded", function () { apply(); resolve(window.FV_CONTENT); });
      });
    }
    apply();
    return window.FV_CONTENT;
  });
})();
